import React from "react";

const InputTableTitle = ({ serviceType, selectedLocation, translations }) => (
	<div className="flex flex-col self-start text-start text-sm">
		<span className="flex gap-1  text-ipxon-magenta uppercase">
			{translations["InputTableTitleOne"]} {translations[serviceType]} {""}
			{translations["InputTableTitleTwo"]} {selectedLocation.name}
		</span>
	</div>
);

export default InputTableTitle;
